import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { AuthenticateRequest, AuthenticateResponse } from "../contracts";
import { getApiBaseUrl } from "./api";

export const authApi = createApi({
    reducerPath: "authApi",
    baseQuery: (args, api, extraOptions) => {
        return fetchBaseQuery({ baseUrl: getApiBaseUrl() })(args, api, extraOptions);
    },
    endpoints: builder => ({
        login: builder.mutation<AuthenticateResponse, AuthenticateRequest>({
            query: body => ({
                url: "authentication",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useLoginMutation
} = authApi;
